var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import * as insightsAPI from '@debbie/cortex/dist/api/insights';
import { UpdateType } from '@debbie/common/dist/updates';
import { BulkActionType, } from '@debbie/common/dist/insights/bulk-actions';
import { selectWorkflows } from '@debbie/cortex/dist/workflows/selectors';
import { getNextTasks } from '@debbie/common/dist/workflows';
import { selectUpdateTypesMap } from '@debbie/cortex/dist/update-types/selectors';
import { Button, Checkbox, Modal, PlaceholderLoader } from '..';
import { Menu, Play } from '../Icons';
import THEME from '../../theme';
import UpdateTypeLabel from '../UpdateTypeLabel';
import ActiveUpdate from '../CasePauseStatus/ActiveUpdate';
const TodoBulkActions = (props) => {
    var _a;
    const { updates, checkedUpdates, setCheckedUpdates, caseFilter } = props;
    const lang = useSelector((state) => state.lang);
    const [bulkActionModalOpen, setBulkActionModalOpen] = useState(false);
    const updatesToBulk = Object.values(checkedUpdates).length
        ? updates.filter((update) => checkedUpdates[update.referenceId])
        : [];
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: {
                marginBottom: '.5em',
            } },
            ((_a = updates[0]) === null || _a === void 0 ? void 0 : _a.updateTypeId) !== UpdateType.SentToConnectPartner && (React.createElement("span", { style: {
                    color: updatesToBulk.length > 1 ? THEME.COLOR_ACCENT : '#6e6e6e',
                    fontWeight: '900',
                    fontSize: '.7em',
                    cursor: 'pointer',
                    float: 'right',
                }, onClick: () => {
                    if (updatesToBulk.length > 1) {
                        setBulkActionModalOpen(!bulkActionModalOpen);
                    }
                    else {
                        alert(lang.updates.chooseMoreThanTwoBulkActions);
                    }
                } },
                lang.updates.bulkActions,
                ' ',
                React.createElement(Menu, { style: {
                        margin: '.2em 0 -.2em',
                    } }))),
            React.createElement(Checkbox, { checkMark: true, checkboxStyle: {
                    fontSize: '16px',
                }, style: {
                    color: THEME.COLOR_ACCENT,
                    fontWeight: '900',
                    fontSize: '.7em',
                    cursor: 'pointer',
                }, checked: !updates.find((update) => !checkedUpdates[update.referenceId]), onChange: (e) => {
                    if (e.target.checked) {
                        setCheckedUpdates(updates.reduce((acc, update) => {
                            acc[update.referenceId] = true;
                            return acc;
                        }, {}));
                    }
                    else {
                        setCheckedUpdates({});
                    }
                }, placeholder: lang.updates.selectAll })),
        bulkActionModalOpen && (React.createElement(Modal, { header: lang.updates.bulkActions, onToggle: () => setBulkActionModalOpen(!bulkActionModalOpen), maxWidth: "1200px" },
            React.createElement(BulkActionsTasks, { updatesToBulk: updatesToBulk, caseFilter: caseFilter })))));
};
export default TodoBulkActions;
const BulkActionsTasks = (props) => {
    const { updatesToBulk, caseFilter } = props;
    const [updatesDone, setUpdatesDone] = useState(false);
    const [wfDone, setWfDone] = useState({});
    const workflowTasks = Object.values(updatesToBulk.reduce((acc, update) => {
        if (update.workflowId && update.taskId) {
            if (!acc[update.workflowId]) {
                acc[update.workflowId] = {
                    updateTypeId: update.updateTypeId,
                    taskId: update.taskId,
                    workflowId: update.workflowId,
                    updates: [],
                };
            }
            acc[update.workflowId].updates =
                acc[update.workflowId].updates.concat(update);
        }
        return acc;
    }, {}));
    const continueTasks = updatesToBulk.reduce((acc, update) => {
        if (!(update.workflowId && update.taskId)) {
            acc = acc.concat(update);
        }
        return acc;
    }, []);
    return (React.createElement("div", null,
        workflowTasks.length
            ? workflowTasks.map((wT) => !wfDone[wT.workflowId] ? (React.createElement(WorkflowTask, { key: wT.workflowId, workflowId: wT.workflowId, queuedTodos: wT.updates, updateTypeId: wT.updateTypeId, taskId: wT.taskId, caseFilter: caseFilter, onDone: () => {
                    setWfDone(Object.assign(Object.assign({}, wfDone), { [wT.workflowId]: true }));
                } })) : null)
            : null,
        !updatesDone && continueTasks.length ? (React.createElement(Update, { updateTypeId: continueTasks[0].updateTypeId, queuedTodos: continueTasks, caseFilter: caseFilter, onDone: () => {
                setUpdatesDone(true);
            } })) : null));
};
const WorkflowTask = (props) => {
    const { workflowId, queuedTodos, updateTypeId, taskId, caseFilter } = props;
    const workflows = useSelector(selectWorkflows);
    const workflow = workflows === null || workflows === void 0 ? void 0 : workflows.find((w) => w.workflowId === workflowId);
    const updateTypesMap = useSelector(selectUpdateTypesMap);
    const updateType = updateTypesMap[updateTypeId];
    if (!updateType) {
        return null;
    }
    const next = workflow ? getNextTasks(workflow, taskId) : null;
    if (!workflow) {
        return React.createElement(PlaceholderLoader, null);
    }
    return (React.createElement(ActiveUpdate, { actions: React.createElement(React.Fragment, null, next &&
            next.map(({ task }) => (React.createElement(NextTaskButton, { targetTask: task, caseFilter: caseFilter, workflowId: workflowId, updateTypeId: updateTypeId, queuedTodos: queuedTodos, onDone: props.onDone })))), updateTypeId: updateTypeId, quantity: queuedTodos.length, description: workflow.title }));
};
const NextTaskButton = (props) => {
    const { caseFilter, targetTask, workflowId, updateTypeId, queuedTodos } = props;
    const [loadingBulkAction, setLoadingBulkAction] = useState(false);
    const updateTypesMap = useSelector(selectUpdateTypesMap);
    const updateType = updateTypesMap[targetTask.updateTypeId];
    if (!updateType) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { loading: loadingBulkAction, size: "small", onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                setLoadingBulkAction(true);
                try {
                    const bulkActionToTask = {
                        type: BulkActionType.MoveCaseToWorkflowTask,
                        details: {
                            workflowId,
                            targetTaskId: targetTask.id,
                        },
                    };
                    yield insightsAPI.caseFilterBulk(Object.assign(Object.assign({}, caseFilter), { caseIds: queuedTodos.map((todo) => todo.referenceId) }), bulkActionToTask, {
                        noConfirmationEmail: true,
                    });
                    // TODO: Continue source update on backend
                    const bulkActionContinue = {
                        type: BulkActionType.ContinueCases,
                        details: {
                            updateTypeId,
                        },
                    };
                    yield insightsAPI.caseFilterBulk(Object.assign(Object.assign({}, caseFilter), { caseIds: queuedTodos.map((todo) => todo.referenceId) }), bulkActionContinue, {
                        noConfirmationEmail: true,
                    });
                }
                catch (error) {
                    console.error(error);
                    alert('Error');
                }
                setLoadingBulkAction(false);
                props.onDone();
            }) },
            React.createElement(UpdateTypeLabel, { label: updateType.label, updateTypeId: updateType.updateTypeId })),
        ' '));
};
const Update = (props) => {
    const { updateTypeId, queuedTodos, caseFilter } = props;
    const lang = useSelector((state) => state.lang);
    const updateTypesMap = useSelector(selectUpdateTypesMap);
    const updateType = updateTypesMap[updateTypeId];
    if (!updateType) {
        return null;
    }
    const continueButton = !updateType.pausing;
    const [loadingBulkAction, setLoadingBulkAction] = useState(false);
    return (React.createElement(ActiveUpdate, { actions: React.createElement(Button, { blockOnMobile: true, loading: loadingBulkAction, size: "small", theme: continueButton ? 'secondary' : 'warning', onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                setLoadingBulkAction(true);
                try {
                    const bulkActionContinue = {
                        type: BulkActionType.ContinueCases,
                        details: {
                            updateTypeId,
                        },
                    };
                    yield insightsAPI.caseFilterBulk(Object.assign(Object.assign({}, caseFilter), { caseIds: queuedTodos.map((todo) => todo.referenceId) }), bulkActionContinue, {
                        noConfirmationEmail: true,
                    });
                }
                catch (error) {
                    console.error(error);
                    alert('Error');
                }
                setLoadingBulkAction(false);
                props.onDone();
            }) },
            React.createElement(Play, { style: { margin: '0.1em 0 -.2em' } }),
            ' ',
            continueButton
                ? lang.updates.continueCaseRemove
                : lang.updates.continueCase), updateTypeId: updateTypeId, quantity: queuedTodos.length }));
};
//# sourceMappingURL=TodoBulkActions.js.map